exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.date-tabs[data-v-170b01b0] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  max-height: 52px;\n}\n@media only screen and (max-width: 1023px) {\n.date-tabs[data-v-170b01b0] {\n      margin-bottom: 16px;\n}\n}\n.tab-btn[data-v-170b01b0] {\n  max-height: 40px;\n  margin: 0 5px;\n  padding: 8px;\n  color: #578AD6;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n}\n.tab-btn.selected[data-v-170b01b0] {\n    color: #578AD6;\n    border-bottom: 1px solid #578AD6;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-170b01b0","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/sales/sale_details/components/chart/ChartWidget.DateTabs.vue
// module id = Yh/2
// module chunks = 1